// A single short shake of the invalid quantity control after a cart partial renders.
class SMinOrderAttention extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const control = this.parentElement;
    if (!control) return;
    this.animation = control.animate([
      { transform: 'translateX(0)' },
      { transform: 'translateX(-4px)' },
      { transform: 'translateX(4px)' },
      { transform: 'translateX(-3px)' },
      { transform: 'translateX(3px)' },
      { transform: 'translateX(0)' }
    ], { duration: 380, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', delay: 120 });
  }
  disconnectedCallback() { this.animation?.cancel(); }
}
if (!customElements.get('s-min-order-attention')) customElements.define('s-min-order-attention', SMinOrderAttention);
